{
  "FRONTEND": {
    "LOOP": {
      "LOAD_MORE_COMMENTS": "Load More Comments",
      "MORE_LIKES_TEXT": "more...",
      "RESULTS": "{{results}} results",
      "NEW_COMMENT_TOOLTIP": "Press enter to submit",
      "FILTER": "Filter",
      "FILTERS": {
        "PLACEHOLDERS": {
          "MARKET": "Filter by market",
          "SALES_TEAM": "Filter by sales team",
          "SALESPEOPLE": "Filter by salespeople",
          "TASK_MANAGER_USERS": "Filter by Task Manager users",
          "ACCOUNT_STATUS": "Filter by account status",
          "ACTION_TAKEN": "Filter by action taken",
          "SELECT_FILTERS": "Select filters"
        },
        "SALESPEOPLE": "Salespeople",
        "TASK_MANAGER_USERS": "Task Manager users",
        "SALES_TEAM": "Sales Team",
        "SALES": "Sales",
        "ACCOUNT_STATUS": {
          "TYPE": "Account Status",
          "STATUSES": "Statuses",
          "IN_PROGRESS": "In Progress",
          "FOLLOW_UP_NEEDED": "Follow-up Needed",
          "CLOSED_WON": "Closed Won",
          "CLOSED_LOST": "Closed Lost"
        },
        "ACTION_TAKEN": {
          "TYPE": "Action Taken",
          "ACTIONS": "Actions",
          "EMAIL_SENT": "Email Sent",
          "EMAIL_RECEIVED": "Email Received",
          "INBOUND_MESSAGE": "Inbound Message",
          "INBOUND_CALL": "Inbound Call",
          "OUTBOUND_CALL": "Outbound Call",
          "MEETING": "Meeting"
        },
        "DATE_RANGE": {
          "TYPE": "Date Range",
          "FROM": "From",
          "TO": "To"
        }
      },
      "ERRORS": {
        "ERROR_COMMENTING": "There was an error commenting, please try again",
        "ERROR_LOADING_COMMENTS": "There was an error loading comments, please try again",
        "ERROR_LOADING_SALES_PEOPLE": "There was an error loading salespeople, please try again",
        "ERROR_LOADING_SALES_TEAMS": "There was an error loading sales teams, please try again",
        "ERROR_LOADING_POSTS": "There was an error loading posts, please try again",
        "ERROR_UNLIKING_POST": "There was an error unliking the post, please try again",
        "ERROR_LIKING_POST": "There was an error liking the post, please try again",
        "ERROR_FOLLOWING_POST": "There was an error following the post, please try again",
        "ERROR_UNFOLLOWING_POST": "There was an error unfollowing the post, please try again",
        "ERROR_LOADING_MARKETS": "There was an error loading markets, please try again",
        "ERROR_LOADING_POST": {
          "TITLE": "Couldn't load post!",
          "MSG": "There was an error loading the post, please try again."
        },
        "CREATE_EMPTY_FILTER_ERROR": "Can't create a filter with empty name",
        "REMOVE_FILTER_ERROR": "Can't remove a filter that doesn't exist"
      },
      "LIKE": "Like",
      "LIKES": "Like(s)",
      "ADD_A_COMMENT": "Add a comment",
      "READ_MORE": "Read more",
      "READ_LESS": "Read less",
      "UNKNOWN_USER": "Unknown User",
      "ADMIN": "Admin",
      "MARKET": "Market",
      "FOLLOW": "Follow",
      "FOLLOWING": "Following",
      "SHARE": "Share",
      "COPIED_TO_CLIPBOARD": "Copied post link to clipboard",
      "ACTION_LABELS": {
        "CANCEL": "Cancel",
        "SAVE": "Save"
      },
      "EMPTY": "No posts found",
      "VALUES": "values",
      "ALL_CHANNELS": "All channels",
      "VIEW_ALL_POSTS": "View All Posts",
      "RECENT_POSTS": "Recent Posts From the Loop"
    }
  }
}
